import React, { useState } from "react";
import { toast } from "react-toastify";
import { Form, Button, Container, Row, Col, Card } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import ApiService from "../services/ApiService";
import logo from "../assets/images/logo.png";
import Header from "../components/Header";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [isLoader, setIsLoader] = useState(false);

  const [formData, setFormData] = useState({
    email: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoader(true);
    try {
      const response = await ApiService.request({
        method: "POST",
        url: `forgotPassword`,
        data: formData,
      });
      const data = response.data;
      if (data.status) {
        toast.success(data.message);
        navigate('/reset-password?user_id='+data.data.user._id);
      } else {
        toast.error(data.message);
      }
      setIsLoader(false);
    } catch (error) {
      toast.error("ForgotPassword failed!");
      setIsLoader(false);
    }
  };

  return (
    <>
      
      

      <Container  className="p-0 signIn-form bg-gradient main-heading">
      
        <Header title={'Forgot Password'}  />


        <Row className="justify-content-center">
          <Col md={8} className="p-4">
            <h4 className="mb-3">Forgot Password</h4>
            <p>
              Forgot your password? Don't worry just enter your email and get recovery email to get reset it.
            </p>
            <p>
              Please do not share that email with anyone. <br />
            </p>
          </Col>
          <Col md={5} className="signIn-form">
            <Card className="p-4">
              <h5 className="fw-light mb-4">
                Forgot password, please enter email:
              </h5>

              <Form onSubmit={handleSubmit}>
                <Form.Group controlId="email" className="mb-3">
                  <Form.Label>* Username/Email:</Form.Label>
                  <Form.Control
                    type="text"
                    name="email"
                    placeholder="Enter Username/Email Address"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-75 inp-s"
                  />
                </Form.Group>


                <Button type="submit" className="w-50 btn btn-base"   disabled={isLoader}>
                  Forgot Password 
                  {isLoader &&  <div class="spinner-border spinner-border-sm mx-2" role="status">    </div> } 
                </Button>
              </Form>

           
            </Card>
          </Col>

          <Col md={3} className="mt-4 mt-md-0">
            <Card className="p-4">
              <h5>Already, have an account:</h5>
              <Link to={"/login"} className="w-50 create-acc">
                Login
              </Link>
            </Card>
          </Col>
        </Row>

      </Container>

    </>
  );
};

export default ForgotPassword;
